// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2-Fzb","loaderOuter":"PageOverlayLoader_loaderOuter__3Y7q0"};